import React from 'react';
import styled from 'astroturf/react';

import routes from 'js/core_pre_webpack/routes';
import { TextButtonLink } from 'js/design_system/link/TextButtonLink';
import PremiumLock from 'js/premium/PremiumLock';
import { ImpressionWatcher } from 'js/utils/impressions/ImpressionWatcher';

import { NavButtonLink } from './buttonStyles';
import { ChurnedUserReactivationDiscount } from './types';

const TRIGGER = 'reactivate_button';

const Text = styled.div`
  white-space: inherit;
  text-align: center;
`;

const NoWrapSpan = styled.span`
  white-space: nowrap;
`;

const ButtonWrapper = styled.div`
  flex-basis: 220px;
  flex-shrink: 0;
`;

type ChurnedUserReactivationButtonProps = {
  discount: ChurnedUserReactivationDiscount;
  isMobileNav: boolean;
};

export default function ChurnedUserReactivationButton({
  discount: { offer, value },
  isMobileNav,
}: ChurnedUserReactivationButtonProps) {
  const checkoutUrl = routes.checkout_path({
    feature: 'churned_user_reactivation',
    trigger: TRIGGER,
    from_navbar: true,
  });

  const buttonContent =
    offer === 'discount' ? (
      <Text>
        Reactivate Premium, <NoWrapSpan>{value} OFF</NoWrapSpan>
      </Text>
    ) : (
      <Text>
        Reactivate Premium <NoWrapSpan>for {value}</NoWrapSpan>
      </Text>
    );

  if (isMobileNav) {
    return (
      <ImpressionWatcher source={TRIGGER} extra={{ offer }}>
        <TextButtonLink
          href={checkoutUrl}
          icon={<PremiumLock circleColor="gold" lockColor="white" />}
          trackClick={{ source: 'churned_user_reactivation_button' }}
          style={{ flexShrink: 1 }}
        >
          {buttonContent}
        </TextButtonLink>
      </ImpressionWatcher>
    );
  }

  return (
    <ButtonWrapper>
      <ImpressionWatcher source={TRIGGER} extra={{ offer }}>
        <NavButtonLink
          href={checkoutUrl}
          icon={<PremiumLock circleColor="white" lockColor="blue" />}
          trackClick={{ source: 'churned_user_reactivation_button' }}
        >
          {buttonContent}
        </NavButtonLink>
      </ImpressionWatcher>
    </ButtonWrapper>
  );
}
